var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5rem",
    height: "1.5rem",
    stroke: "currentColor",
    strokeWidth: 0,
    viewBox: "0 0 26 26",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9987 20.8542C15.5415 20.8542 17.6029 18.7929 17.6029 16.25C17.6029 13.7072 15.5415 11.6459 12.9987 11.6459C10.4559 11.6459 8.39453 13.7072 8.39453 16.25C8.39453 18.7929 10.4559 20.8542 12.9987 20.8542Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4066 14.0508C24.4066 14.0508 23.7522 13.3965 22.7664 12.4096C17.3714 7.01566 8.62675 7.01566 3.23174 12.4096C2.24591 13.3965 1.59158 14.0508 1.59158 14.0508C1.27416 14.3672 1.27416 14.8828 1.59158 15.1992C1.90791 15.5166 2.42358 15.5166 2.73991 15.1992C2.73991 15.1992 3.39424 14.5448 4.38116 13.559C9.14024 8.79882 16.8579 8.79882 21.617 13.559C22.6039 14.5448 23.2582 15.1992 23.2582 15.1992C23.5746 15.5166 24.0902 15.5166 24.4066 15.1992C24.724 14.8828 24.724 14.3672 24.4066 14.0508Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4207 7.43926L18.7957 10.2538C18.5725 10.6416 18.7057 11.1388 19.0936 11.3631C19.4814 11.5873 19.9797 11.4541 20.204 11.0663L21.829 8.25176C22.0522 7.86284 21.9189 7.36559 21.5311 7.14134C21.1432 6.91709 20.6449 7.05034 20.4207 7.43926Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1875 5.95837V9.20837C12.1875 9.65687 12.5515 10.0209 13 10.0209C13.4485 10.0209 13.8125 9.65687 13.8125 9.20837V5.95837C13.8125 5.50987 13.4485 5.14587 13 5.14587C12.5515 5.14587 12.1875 5.50987 12.1875 5.95837Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17066 8.25176L5.79566 11.0663C6.01991 11.4541 6.51824 11.5873 6.90607 11.3631C7.29391 11.1388 7.42716 10.6416 7.20399 10.2538L5.57899 7.43926C5.35474 7.05034 4.85641 6.91709 4.46857 7.14134C4.08074 7.36559 3.94749 7.86284 4.17066 8.25176Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.c9eae4df5a0b8beb2bb199b27f9f048e.svg";
export { ForwardRef as ReactComponent };